export enum ChangePageType {
    NEXT = 'Next',
    PREV = 'Prev'
}